import { render, staticRenderFns } from "./SiteViewsChart.vue?vue&type=template&id=2dbe7f0e&scoped=true&lang=pug&"
import script from "./SiteViewsChart.vue?vue&type=script&lang=js&"
export * from "./SiteViewsChart.vue?vue&type=script&lang=js&"
import style0 from "./SiteViewsChart.vue?vue&type=style&index=0&id=2dbe7f0e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe7f0e",
  null
  
)

/* custom blocks */
import block0 from "./SiteViewsChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports